export default function(html) {
	html.querySelectorAll('[data-bs-toggle="modal"][data-bs-target="#contentPreviewModal"]').forEach((el) => {
		el.addEventListener('click', (e) => {
			const editBtn = html.querySelector('#contentPreviewModal .modal-footer .edit-btn')
			editBtn.setAttribute('href', el.dataset.edit)

			const publishBtn = html.querySelector('#contentPreviewModal .modal-footer .publish-btn')
			const rejectBtn = html.querySelector('#contentPreviewModal .modal-footer .reject-btn')
			const publishUrl = el.dataset.publish

			if (publishUrl === '#') {
				publishBtn.classList.add('d-none')
				rejectBtn.classList.add('d-none')
			} else {
				publishBtn.classList.remove('d-none')
				rejectBtn.classList.remove('d-none')

				publishBtn.setAttribute('href', publishUrl)
			}

			html.querySelector('#returnForRevisionModal').querySelector('input[name=id]').value = el.dataset.id
		})
	})


	for (let section of ['web', 'intranet']) {
		const selector = '[data-bs-toggle="modal"][data-bs-target="#contentPreviewModal"][data-' + section + '-url]'
		html.querySelectorAll(selector).forEach((el) => {
			el.addEventListener('click', (e) => {
				html.querySelectorAll('#contentPreviewModal iframe').forEach((el) => {
					el.classList.add('d-none')
				})

				const loader = html.querySelector('#contentPreviewLoader')
				loader.classList.remove('d-none')

				html.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link').forEach((el) => {
					el.classList.add('disabled')
					el.classList.remove('active')
				})

				const navBtn = html.querySelector('#contentPreviewModal li.nav-item.' + section + ' button.nav-link')
				navBtn.classList.remove('disabled')

				if (html.querySelectorAll('#contentPreviewModal li.nav-item button.nav-link.active').length === 0) {
					navBtn.classList.add('active')
				}

				const iframe = html.querySelector('#contentPreviewModal iframe.' + section)
				iframe.classList.add('d-none')

				const url = e.currentTarget.getAttribute('data-' + section + '-url')
				if (url) {
					const callback = (e) => {
						loader.classList.add('d-none')
						e.currentTarget.classList.remove('d-none')
					}

					iframe.removeEventListener('load', callback)
					iframe.addEventListener('load', callback)

					iframe.setAttribute('src', url)

				} else {
					alert('URL not found.')
				}
			})
		})
	}
}
